import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import download from '../../assets/Images/icons8-download-24.png';
import loader from '../../assets/Images/loader.gif';
import { click } from '@testing-library/user-event/dist/click';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const FaultRepairDotSr = () => {
  const navigate = useNavigate();
  const [DotSrData, setDotSrData] = useState([])
  const [loading, setLoading] = useState(false);
  const [EngineerSRs, setEngineerSrs] = useState([]);
  const [flagon, setflagOn] = useState(false)

  const EmailID = sessionStorage.getItem('userEmail')


  const redirectDashboardPage = () => {
    navigate('/faultRepair')
  }

  const redirectToViewSr = (sr) => {
    // console.log('srNumber',sr)
    const srNo = sr.srNumber
    navigate(`/faultRepairViewSr?srNumber=${srNo}`);
  }

  // Fault repair DOT SR Api
  useEffect(() => {
    const FetchDotSRs = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "assignmentDOT",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          emailID: EmailID

        };
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
        });
        if (response.ok) {
          const result = await response.json();
          // console.log('API Response of DOT Sr:', result);
          // setEngineerSrs(result.response);
          setLoading(false);
          if (result && result.response && result.response.Status !== "Failure") {

            setEngineerSrs(result.response);
            setflagOn(true)
          } else {

            // console.log('result.ErrorDesc', result.ErrorDesc);
            const errorMessage = (result.ErrorDesc);
            toast.warning(`${errorMessage}`, {
              position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
            });
          }
        } else {
          console.error('Error fetching data:', response.status);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    }
    if (EmailID) {
      FetchDotSRs()
    }

  }, []);

  // END 






  return (
    <>
      {/* {Header} */}
      <div className="container-fluid text-light Header-style header" >
        <div className="p-3">
          <span className='' style={{ cursor: 'pointer' }} onClick={redirectDashboardPage}>
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className='p-1 m-3'>DOT SR's</span>
        </div>
      </div>
      <div className="container-fluid faultRepair-main">

        {flagon && <div className="row justify-content-center" >



          {loading ? (
            <div className="loader-wrapper">
              <div className="loader">
                <img src={loader} alt="loading...."></img>
              </div>
            </div>
          ) : (
            <div className=" container-fluid">
              <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3" >
             
                  {EngineerSRs.map((sr, index) => (
                    <div className='col'>
                    <div className="card mb-3" >
                      <div className="p-2 card-data" >
                        <div>
                          <div className="lead-card">
                            <div className="row">
                              <div className="col-5"  >SR Number</div>
                              <div className="col-1">:</div>
                              <div className="col-6">{sr.srNumber}</div>
                            </div>
                            <div className="row">
                              <div className="col-5">Customer Id </div>
                              <div className="col-1">:</div>
                              <div className="col-6" style={{ color: 'red' }}>{sr.customerID}</div>
                            </div>
                            <div className="row">
                              <div className="col-5">SLA Status :</div>
                              <div className="col-1">:</div>
                              <div className="col-6">{sr.slaStatus}</div>
                            </div>
                            <div className="row">
                              <div className="col-5">Mobile Number</div>
                              <div className="col-1">:</div>
                              <div className="col-6">{sr.customerMobile}</div>
                            </div>
                            <div className="row">
                              <div className="col-5">Customer Name </div>
                              <div className="col-1">:</div>
                              <div className="col-6">{sr.customerName}</div>
                            </div>
                            <div className="row">
                              <div className="col-5">Address</div>
                              <div className="col-1">:</div>
                              <div className="col-6">{sr.customerAddress}</div>
                            </div>
                            <div className="row">
                              <div className="col-5">Sub SR Type </div>
                              <div className="col-1">:</div>
                              <div className="col-6">{sr.srSubType}</div>
                            </div>
                            <div className="row">
                              <div className="col-5">Customer Segment</div>
                              <div className="col-1">:</div>
                              <div className="col-6">{sr.segment}</div>
                            </div>
                            <div className="row">
                              <div className="col-5">SR Type</div>
                              <div className="col-1">:</div>
                              <div className="col-6">{sr.srType}</div>
                            </div>
                            <div className="row">
                              <div className="col-5">SLA Clock </div>
                              <div className="col-1">:</div>
                              <div className="col-6">{sr.slaClock}</div>
                            </div>
                          </div>
                          
                          <div className="text-center mt-5 mb-3">

                            <button
                              type="submit"
                              className="btn text-light w-75 bg-dark mx-auto rounded-pill"
                              onClick={() => redirectToViewSr(sr)}
                            >
                              View
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    </div>

                  ))}
                </div>
              </div>
          )}

        </div>}
      </div>






    </>
  )
}


export default FaultRepairDotSr